import { useEffect } from "react"

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      // ignore if self or children
      if (!ref.current || ref.current.contains(event.target)) return
      setTimeout(() => handler(event), 180)
    }

    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)

    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
    }
  }, [ref, handler])
}
